import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=791b5262&scoped=true"
import script from "./FormTitle.vue?vue&type=script&lang=js"
export * from "./FormTitle.vue?vue&type=script&lang=js"
import style0 from "./FormTitle.vue?vue&type=style&index=0&id=791b5262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791b5262",
  null
  
)

export default component.exports